module.exports = __webpack_public_path__ + "static/ryan-hoover-7f13c07e3f877c2493fc3bc15383de21.jpg";